import { chakra } from '@chakra-ui/react';
import { formatCountdown } from 'components/common/ToastNotifications/utils/time';
import { differenceInSeconds, parseISO } from 'date-fns';
import { Fragment } from 'react';
import type { LiveNotification } from 'types/cms/ToastNotification';

import { TimeText } from './TimeText';

const FORMAT = ['H', 'M', 'S'];

export function Countdown({
  times,
  currentTime,
}: {
  times: LiveNotification['displayTimes'];
  currentTime: Date;
}) {
  const secondsUntilStart = differenceInSeconds(
    parseISO(times.dateRange.startDate),
    currentTime,
  );

  const formatted = formatCountdown(secondsUntilStart);

  return (
    <TimeText
      sx={{
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {(FORMAT as (keyof typeof formatted)[]).map((delimiter, i) => (
        <Fragment key={delimiter}>
          {formatted[delimiter].time}
          <chakra.span color="whiteAlpha.600">
            {`${formatted[delimiter].unit}${i < FORMAT.length - 1 ? ' ' : ''}`}
          </chakra.span>
        </Fragment>
      ))}
    </TimeText>
  );
}
